module.exports = __webpack_public_path__ + "static/media/healthkit_summary.92ae82ad.png";